const { createObject, createString, traversePropertiesString } = require('../../shared');

module.exports.payment = function (appData, formData, outData){

  if (!outData.error && !createObject(appData, "payment", {immediate: false})) {
    outData.error = "Cannot create payment info";
  }

  const method = traversePropertiesString(formData,['payment','method']);

  if (!outData.error && !createString(appData.payment, "method", method, true)) {
    outData.error = "Missing payment method";
  }

  if (!outData.error) {
    if (method === "eft") {

      if (!outData.error && !createObject(appData.payment, "eft", {})) {
        outData.error = "Cannot create eft info";
      }
      if (!outData.error && !createString(appData.payment.eft, "bankName", traversePropertiesString(formData,['payment','bankName']), true)) {
        outData.error = "Missing payment bankName";
      }
      if (!outData.error && !createString(appData.payment.eft, "bankStreet", traversePropertiesString(formData,['payment','bankAddress']), false)) {
        outData.error = "Missing payment bankStreet";
      }
      if (!outData.error && !createString(appData.payment.eft, "bankZip", traversePropertiesString(formData,['payment','bankZip']), false)) {
        outData.error = "Missing payment bankZip";
      }
      if (!outData.error && !createString(appData.payment.eft, "routingNumber", traversePropertiesString(formData,['payment','routingNumber']), true)) {
        outData.error = "Missing payment routingNumber";
      }
      if (!outData.error && !createString(appData.payment.eft, "accountNumber", traversePropertiesString(formData,['payment','accountNumber']), true)) {
        outData.error = "Missing payment accountNumber";
      }

    } else if (method === "check") {
      if (!outData.error && !createObject(appData.payment, "check", {})) {
        outData.error = "Cannot create check info";
      }
      if (!outData.error && !createString(appData.payment.check, "freq", traversePropertiesString(formData,['payment','frequency']), true)) {
        outData.error = "Missing payment method";
      }
    } else {
      outData.error = "Invalid Payment method type";
    }
  }

};


// WEBPACK FOOTER //
// ./src/containers/Applications/shared/appConverters/MBA/payment.js